@if (isLoader || status === CHANNEL_STATUS.PROCESSING) {
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Prom'"></app-sidebar-header>
  <div class="prom-loader-container">
    <app-loader size="big"></app-loader>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <div class="h-100 overflow-auto crm-scroll prom-integration-container">
    <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Prom'" />
    <mat-card class="shadow-none bg-transparent">
      <mat-card-content class="d-flex flex-column bg-white rounded-2 m-3 p-4">
        <div class="header-container">
          <div class="icon-logo">
            <img src="/assets/svgs/integrations/prom.svg" alt="Prom logo" />
          </div>
        </div>

        <div class="pt-3">
          <p>{{ 'channel' | translate }}: {{ channel_name }}</p>
          <p>{{ 'status'| translate }}:
            @if (CHANNEL_STATUS_OBJECT[status]) {
              <span class="badge" [ngStyle]="{'background-color': CHANNEL_STATUS_OBJECT[status].color}">
                  {{ 'channel_status_new.' + CHANNEL_STATUS_OBJECT[status].textKey | translate }}
                </span>
            }
          </p>
          <div class="d-flex gap-2 flex-wrap flex-column justify-content-center">
            @switch (status) {
              @case (CHANNEL_STATUS.CONNECTED) {
                <app-button class="d-flex justify-content-center" btnType="stroked"
                            (onChangeClick)="deleteChannel()">{{ 'delete'| translate }}
                </app-button>
              }
              @default {
                <app-input
                  [formControl]="tokenControl"
                  [required]="true"
                  placeholder="{{'token' | translate}}"
                  label="{{'token' | translate}}"
                />
                <app-button class="d-flex justify-content-center"
                            (onChangeClick)="connectAccount()">{{ 'connect' | translate }}
                </app-button>
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
